import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import styles from "../../styles/tenant.module.css"
import { useMutation } from "@apollo/client";
import DeleteModal from "./DeleteModal";
import EditModal from "./EditModal";
import ApiConfigModal from "./ApiConfigModal";
import AddApiConfigModal from "./AddApiConfigModal";
import EditApiConfigModal from "./EditApiConfigModal";
import AddDataIntegrationModal from "./AddDataIntegrationModal";
import DataIntModal from "./DataIntModal";
import EditDataIntModal from "./EditDataIntModal";
import ErrorDisplay from "../common/ErrorDisplay";
import { DISABLE_TENANT, ENABLE_TENANT, LOAD_TENANTS } from "../../graphql/TenantQueries";

function EditDeleteModal({ setOpenActionModal, fieldData, tenantMeta }: any) {
    const isDisabled = tenantMeta?.disabled === true;
    const [confirmDisable, setConfirmDisable] = useState(false);
    const [confirmEnable, setConfirmEnable] = useState(false);
    const [disableTenant, { loading: isDisabling, error: disableError }] = useMutation(DISABLE_TENANT, { refetchQueries: [{ query: LOAD_TENANTS }] });
    const [enableTenant, { loading: isEnabling, error: enableError }] = useMutation(ENABLE_TENANT, { refetchQueries: [{ query: LOAD_TENANTS }] });
    const mutationError = disableError || enableError;
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openEditModal, setOpenEditModal] = useState(false)
    const [openApiModal, setOpenApiModal] = useState(false)
    const [openAddApiModal, setOpenAddApiModal] = useState(false)
    const [openEditApiConfigModal, setOpenEditApiConfigModal] = useState(false)
    const [openAddDataIntModal, setOpenAddDataIntModal] = useState(false)
    const [openEditDataIntModal, setOpenEditDataIntModal] = useState(false)
    const [openDataIntModal, setOpenDataIntModal] = useState(false)

    const handleDisable = async () => {
        try {
            await disableTenant({ variables: { id: fieldData } });
            setOpenActionModal(false);
        } catch (_error) {
            // error surfaced via disableError from useMutation
        }
    };

    const handleEnable = async () => {
        try {
            await enableTenant({ variables: { id: fieldData } });
            setOpenActionModal(false);
        } catch (_error) {
            // error surfaced via enableError from useMutation
        }
    };


    return (
        <div className={styles["modalBackground"]}>
            <div className={styles["modalContainer"]}>
                <div className={styles["title"]}>
                    {!openDeleteModal && !openEditModal && !openApiModal && !openAddApiModal &&
                    !openEditApiConfigModal && !openAddDataIntModal && !openDataIntModal && !openEditDataIntModal &&
                    <><h1>Tenant Actions</h1>
                        {isDisabled && (
                            <div className={styles["disabledWarning"]}>
                                ⚠️ This tenant is currently disabled. Database access is suspended, but configuration changes are saved immediately.
                            </div>
                        )}
                        <div className={styles["body"]}>
                            <div>
                            <div>
                                <hr/>
                                <button className={styles["modalButton"]} onClick={() => setOpenAddApiModal(true) }>Add API Config</button>
                                <button className={styles["modalButton"]} onClick={() => setOpenAddDataIntModal(true) }>Add Integration</button>
                                <hr/>
                                </div>
                                <div>
                                <button className={styles["modalButton"]} onClick={() => setOpenApiModal(true) }>View API Config</button>
                                <button className={styles["modalButton"]} onClick={() => setOpenDataIntModal(true) }>View Integration</button>
                                <hr/>
                                </div>
                                <div>
                                <button className={styles["modalButton"]} onClick={() => setOpenEditApiConfigModal(true) }>Edit API Config</button>
                                <button className={styles["modalButton"]} onClick={() => setOpenEditDataIntModal(true) }>Edit Integration</button>
                                <button className={styles["modalButton"]} onClick={() => setOpenEditModal(true)}>Edit Tenant</button>
                                <hr/>
                                </div>
                                <div>
                                {isDisabled ? confirmEnable ? (
                                    <>
                                        <p style={{ fontSize: '16px', margin: '10px 0' }}>Re-enabling will restore database access. Are you sure?</p>
                                        <button
                                            className={styles["modalButton"]}
                                            onClick={handleEnable}
                                            disabled={isEnabling}
                                        >
                                            {isEnabling ? 'Enabling...' : 'Yes, Enable'}
                                        </button>
                                        <button
                                            className={styles["button"]}
                                            onClick={() => setConfirmEnable(false)}
                                            disabled={isEnabling}
                                        >
                                            Cancel
                                        </button>
                                    </>
                                ) : (
                                    <button
                                        className={styles["modalButton"]}
                                        onClick={() => setConfirmEnable(true)}
                                        disabled={isEnabling}
                                    >
                                        Enable Tenant
                                    </button>
                                ) : confirmDisable ? (
                                    <>
                                        <p style={{ fontSize: '16px', margin: '10px 0' }}>Disabling will terminate active database sessions. Are you sure?</p>
                                        <button
                                            className={styles["cnclButton"]}
                                            onClick={handleDisable}
                                            disabled={isDisabling}
                                        >
                                            {isDisabling ? 'Disabling...' : 'Yes, Disable'}
                                        </button>
                                        <button
                                            className={styles["button"]}
                                            onClick={() => setConfirmDisable(false)}
                                            disabled={isDisabling}
                                        >
                                            Cancel
                                        </button>
                                    </>
                                ) : (
                                    <button className={styles["cnclButton"]} onClick={() => setConfirmDisable(true)}>Disable Tenant</button>
                                )}
                                {!confirmDisable && !confirmEnable && (
                                    <>
                                    <button
                                        className={styles["cnclButton"]}
                                        onClick={() => setOpenDeleteModal(true)}
                                        disabled={isEnabling || isDisabling}
                                    >
                                        Delete Tenant
                                    </button>
                                    <button
                                        onClick={() => setOpenActionModal(false)}
                                        className={styles["button"]}
                                        disabled={isEnabling || isDisabling}
                                    >
                                        Cancel
                                    </button>
                                    </>
                                )}
                                </div>
                                <ErrorDisplay error={mutationError} />
                            </div>
                            <div>
                            </div>
                        </div></>
                    }
                    {openDeleteModal && <DeleteModal fieldData={fieldData} setOpenDeleteModal={setOpenDeleteModal} setOpenActionModal={setOpenActionModal} />}
                </div>
                {openEditModal && <EditModal fieldData={fieldData} setOpenEditModal={setOpenEditModal} setOpenActionModal={setOpenActionModal} />}
                {openApiModal && <ApiConfigModal fieldData={fieldData} setOpenApiModal={setOpenApiModal} setOpenActionModal={setOpenActionModal}/>}
                {openDataIntModal && <DataIntModal fieldData={fieldData} setOpenDataIntModal={setOpenDataIntModal} setOpenActionModal={setOpenActionModal}/>}
                {openAddApiModal && <AddApiConfigModal fieldData={fieldData} setOpenAddApiModal={setOpenAddApiModal} setOpenActionModal={setOpenActionModal}/>}
                {openEditApiConfigModal && <EditApiConfigModal fieldData={fieldData} setOpenEditApiConfigModal={setOpenEditApiConfigModal} setOpenActionModal={setOpenActionModal}/>}
                {openAddDataIntModal && <AddDataIntegrationModal fieldData={fieldData} setOpenAddDataIntModal={setOpenAddDataIntModal} setOpenActionModal={setOpenActionModal}/>}
                {openEditDataIntModal && <EditDataIntModal fieldData={fieldData} setOpenEditDataIntModal={setOpenEditDataIntModal} setOpenActionModal={setOpenActionModal}/>}

            </div>
        </div>
    )
}

export default EditDeleteModal;
